import { z } from 'zod';
import { moneyMinorSchema } from '../api';
import { ATTENDANCE_STATUS, LEAVE_STATUS, LEAVE_TYPE } from '../enums';
const componentSchema = z.object({
    label: z.string().trim().min(1).max(80),
    amountMinor: moneyMinorSchema.min(0),
});
export const upsertEmployeeSchema = z.object({
    userId: z.string().uuid().nullable().optional(),
    employeeNo: z.string().trim().toUpperCase().min(1).max(24).optional(),
    name: z.string().trim().min(2).max(160),
    cnic: z.string().trim().max(20).optional(),
    phone: z.string().trim().max(20).optional(),
    email: z.string().trim().email().max(160).optional(),
    designation: z.string().trim().max(120).optional(),
    departmentId: z.string().uuid().nullable().optional(),
    branchId: z.string().uuid().nullable().optional(),
    joinedAt: z.string().datetime().nullable().optional(),
    contractType: z.enum(['permanent', 'contract', 'visiting', 'intern', 'daily_wage']).default('permanent'),
    contractEndsAt: z.string().datetime().nullable().optional(),
    /** PMDC / nursing council registration; expiry drives the alert list. */
    licenseNo: z.string().trim().max(60).optional(),
    licenseExpiry: z.string().datetime().nullable().optional(),
    basicSalaryMinor: moneyMinorSchema.min(0).default(0),
    allowances: z.array(componentSchema).max(20).default([]),
    deductions: z.array(componentSchema).max(20).default([]),
    bankAccount: z.string().trim().max(60).optional(),
    isActive: z.boolean().default(true),
});
export const rosterSchema = z.object({
    branchId: z.string().uuid().nullable().optional(),
    departmentId: z.string().uuid().nullable().optional(),
    name: z.string().trim().min(2).max(160),
    periodStart: z.string().regex(/^\d{4}-\d{2}-\d{2}$/),
    periodEnd: z.string().regex(/^\d{4}-\d{2}-\d{2}$/),
});
export const rosterShiftSchema = z.object({
    rosterId: z.string().uuid(),
    employeeId: z.string().uuid(),
    shiftDate: z.string().regex(/^\d{4}-\d{2}-\d{2}$/),
    shift: z.enum(['morning', 'evening', 'night']).default('morning'),
    startsAt: z.string().datetime(),
    endsAt: z.string().datetime(),
    wardId: z.string().uuid().nullable().optional(),
    notes: z.string().trim().max(300).optional(),
});
export const attendanceSchema = z.object({
    employeeId: z.string().uuid(),
    workDate: z.string().regex(/^\d{4}-\d{2}-\d{2}$/),
    checkInAt: z.string().datetime().nullable().optional(),
    checkOutAt: z.string().datetime().nullable().optional(),
    status: z.enum(ATTENDANCE_STATUS).default('present'),
    source: z.enum(['manual', 'biometric', 'mobile']).default('manual'),
    latitude: z.number().min(-90).max(90).nullable().optional(),
    longitude: z.number().min(-180).max(180).nullable().optional(),
    notes: z.string().trim().max(300).optional(),
});
export const bulkAttendanceSchema = z.object({
    workDate: z.string().regex(/^\d{4}-\d{2}-\d{2}$/),
    employeeIds: z.array(z.string().uuid()).min(1).max(500),
    status: z.enum(ATTENDANCE_STATUS).default('present'),
});
export const leaveRequestSchema = z.object({
    employeeId: z.string().uuid(),
    type: z.enum(LEAVE_TYPE).default('casual'),
    fromDate: z.string().regex(/^\d{4}-\d{2}-\d{2}$/),
    toDate: z.string().regex(/^\d{4}-\d{2}-\d{2}$/),
    reason: z.string().trim().max(600).optional(),
});
export const leaveDecisionSchema = z.object({
    status: z.enum(LEAVE_STATUS),
    notes: z.string().trim().max(600).optional(),
});
export const payrollRunSchema = z.object({
    periodStart: z.string().regex(/^\d{4}-\d{2}-\d{2}$/),
    periodEnd: z.string().regex(/^\d{4}-\d{2}-\d{2}$/),
    /** Paid per overtime minute, on top of the salary structure. */
    overtimeRatePerHourMinor: moneyMinorSchema.min(0).default(0),
    /** Flat tax percentage; a full slab engine is a tenant-configurable follow-on. */
    taxPct: z.number().min(0).max(100).default(0),
});
//# sourceMappingURL=hr.js.map